module.exports = __webpack_public_path__ + "images/writting-file.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/writting-file.svg
// module id = 954
// module chunks = 0